<template>
  <b-modal
    id="addRemarkModal"
    :title="`Add Remark (${modalTitleExt})`"
    size="md"
    hide-footer
  >
    <b-card>
      <validation-observer
        ref="addRemarkForm"
      >
        <b-form
          enctype="multipart/form-data"
          autocomplete="off"
          @submit.prevent="addRemarkSubmit"
        >
          <b-row>
            <b-col
              cols="12"
              class="p-0"
            >
              <b-form-group
                :label="t('Remark')"
                label-for="vi-remark"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Remark"
                  vid="vi-Remark"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-textarea
                      id="vi-remark"
                      v-model="form.remark"
                      :class="errors[0] ? 'border-red' : ''"
                      :browse-text="t('Browse')"
                      type="text"
                      :placeholder="t('Add Remark')"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              class="p-0"
            >
              <b-form-group
                :label="t('Document')"
                label-for="vi-document"
                class=""
              >
                <validation-provider
                  #default="{ errors }"
                  name="Document"
                  vid="vi-Document"
                  rules=""
                >
                  <b-input-group class="input-group-merge">
                    <b-form-file
                      id="vi-document"
                      v-model="form.document"
                      :class="errors[0] ? 'border-red-file' : ''"
                      :browse-text="t('Browse')"
                      type="file"
                      :placeholder="t('Upload Document')"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                {{ t('Submit') }}
              </b-button>
              <b-button
                type="button"
                variant="outline-secondary"
                @click="remarkModalCancel"
              >
                {{ t('Cancel') }}
              </b-button>
            </b-col>
          </b-row></b-form>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { useUtils } from '@core/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import constants from '@/constants'
import { hideLoader, showLoader } from '@/utils/common'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: ['activity_ids'],
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      form: {
        activity_for_id: this.activity_ids.activity_for_id ? this.activity_ids.activity_for_id : '',
        activity_for: this.activity_ids.activity_for ? this.activity_ids.activity_for : '',
        lead_id: this.activity_ids.lead_id ? this.activity_ids.lead_id : '',
        vendor_id: this.activity_ids.vendor_id ? this.activity_ids.vendor_id : '',
        opportunity_id: this.activity_ids.opportunity_id ? this.activity_ids.opportunity_id : '',
        vendor_unit_id: this.activity_ids.vendor_unit_id ? this.activity_ids.vendor_unit_id : '',
        status: '',
        remark: '',
        document: [],
      },
      modalTitleExt: '',
      addRemarkAPI: '',
    }
  },
  watch: {
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (a, componentId) => {
      if (componentId === 'addRemarkModal') {
        this.form = {
          activity_for_id: this.activity_ids.activity_for_id ? this.activity_ids.activity_for_id : '',
          activity_for: this.activity_ids.activity_for ? this.activity_ids.activity_for : '',
          lead_id: this.activity_ids.lead_id ? this.activity_ids.lead_id : '',
          vendor_id: this.activity_ids.vendor_id ? this.activity_ids.vendor_id : '',
          opportunity_id: this.activity_ids.opportunity_id ? this.activity_ids.opportunity_id : '',
          vendor_unit_id: this.activity_ids.vendor_unit_id ? this.activity_ids.vendor_unit_id : '',
          remark: '',
          status: '',
          document: [],
        }
      }
    })
    this.$root.$on('getstatusid', (a, b) => {
      this.form.status = a
      this.modalTitleExt = b
    })
    // eslint-disable-next-line eqeqeq
    if (this.activity_ids.activity_for == constants.LEAD) {
      this.addRemarkAPI = 'vendorStore/addRemark'
      // eslint-disable-next-line eqeqeq
    } else if (this.activity_ids.activity_for == constants.OPPORTNUITY) {
      this.addRemarkAPI = 'vendorStore/addOpportunityRemark'
    }
  },
  methods: {
    addRemarkSubmit() {
      // eslint-disable-next-line prefer-const
      let formData = new FormData()
      Object.entries(this.form).forEach(
        ([key, value]) => {
          formData.append(key, value)
        },
      )
      this.$refs.addRemarkForm.validate().then(success => {
        if (success) {
          this.addRemark(formData)
        }
      })
    },
    async addRemark(formData) {
      showLoader()
      await store.dispatch(this.addRemarkAPI, formData).then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == constants.SUCCESS) {
          this.$bvModal.hide('addRemarkModal')
          this.$emit('loadAllRemarks')
          this.$root.$emit('refreshLeadData')
          hideLoader()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.msg,
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: '',
            },
          })
          this.$refs.addRemarkForm.reset()
        } else {
          hideLoader()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.msg,
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        }
      }).catch(e => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: e.msg,
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
        hideLoader()
      })
    },
    remarkModalCancel() {
      this.$bvModal.hide('addRemarkModal')
    },
  },
}
</script>

<style>

</style>
